"use client";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { useFooter } from "@/lib/context/FooterContext";
import { useTheme } from "@emotion/react";
import { Stack, Typography, useMediaQuery } from "@mui/material";
import Image from "next/image";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "../Modal";
import { usePathname, useRouter } from "next/navigation";
import ButtonComponent from "../Button";
import { setModalAttributes } from "@/lib/redux/slice/ModalSlice";

const AttemptError = () => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  const { setActions } = useFooter();
  const router = useRouter();
  const dispatch = useDispatch();
  const { open, message, type , routeHome } = useSelector((state) => state?.modal);
  const path = usePathname();
  const handleButtonClick = () => {
    if (type === "ATTEMPT_ERROR" && path && path !== "/en" && routeHome) {
      dispatch(setModalAttributes({ isRouting: true, targetRoute: "/" }));
      router.replace("/");
    }
    dispatch(setModalAttributes({ open: false, message: "", type: "" }));
  };

  return (
    <ModalComponent
      maxWidth={isBelowMd ? "xs" : "md"}
      open={open}
      closeButtonRequired={false}>
      <Stack
        sx={{
          backgroundColor: { md: "#F2F7F799" },
          border: { md: "1px solid #F0F0F099", xs: "none" },
          borderRadius: "20px",
        }}
        spacing={3}
        width={"100%"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        pb={{ md: 10, xs: 2 }}
        pt={{ md: 10, xs: 2 }}>
        <Image
          src={IMAGES.authenticationError}
          width={isBelowMd ? 180 : 250}
          alt="Attempts Exhausted"
        />
        <Stack
          width={{ md: "620px" }}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          spacing={2}>
          {message.label && (
            <Typography
              align="center"
              fontWeight={{ md: 700, xs: 500 }}
              fontSize={{ md: "24px", xs: "16px" }}
              color={WEB_COLORS.darkTeal}
              width={{ md: "553px" }}>
              {message.label}
            </Typography>
          )}
          {message.subLabel && (
            <Typography
              textAlign={"center"}
              fontWeight={400}
              fontSize={{ md: "16px", xs: "14px" }}
              color={WEB_COLORS.textFadeColor}
              mb={2}>
              {message.subLabel}
            </Typography>
          )}
          {message.error && (
            <Typography
              textAlign={"center"}
              fontWeight={400}
              fontSize={{ md: "14px", xs: "12px" }}
              color={WEB_COLORS.errorColor}
              mb={2}>
              {message.error}
            </Typography>
          )}
        </Stack>
        <Stack width={{ md: "300px", xs: "100%" }}>
          <ButtonComponent onClick={handleButtonClick}>
            {type === "ATTEMPT_ERROR" && routeHome ? "Notify Me" : "OK"}
          </ButtonComponent>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default AttemptError;
